<template>
<div class="page-container">
  <el-breadcrumb separator="/">
    <el-breadcrumb-item>
      <span class="page-title">工单处理</span>
    </el-breadcrumb-item>
    <el-breadcrumb-item>登录用户</el-breadcrumb-item>
  </el-breadcrumb>
  <el-card class="page-content" shadow="never">
    <el-tabs :value="activeTab" @tab-click="handleTabChange">
      <el-tab-pane v-for="type in statusTypes" :key="type.value" :label="type.label" :name="type.value"></el-tab-pane>
    </el-tabs>
    <div class="page-actions">
      <el-select v-model="ticketType" placeholder="请选择币种">
        <el-option label="所有类型" value=""></el-option>
        <el-option v-for="type in ticketTypes" :label="type.label" :value="type.value" :key="type.value"></el-option>
      </el-select>
      <el-input placeholder="请输入账号ID" clearable v-model="userId">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
        <el-button slot="append" @click="handleSearch" type="primary">搜索</el-button>
      </el-input>
    </div>
    <ticket-list @refresh="getList"></ticket-list>
  </el-card>
</div>
</template>

<script>
import './store';
import TicketList from './components/list';
import { mapState, mapActions, mapMutations } from 'vuex';
import { STATUS_TYPE, TICKET_TYPE } from './constants.js';

export default {
  name: 'LoginUserTicket',
  data() {
    return {
      ticketType: '',
      userId: ''
    };
  },
  components: {
    TicketList
  },
  computed: {
    ...mapState('loginUserTicket', ['pagination', 'activeTab']),
    statusTypes() {
      return Object.keys(STATUS_TYPE)
        .map(key => ({
          value: key,
          label: STATUS_TYPE[key].text,
          order: STATUS_TYPE[key].order
        }))
        .sort((a, b) => a.order - b.order);
    },
    ticketTypes() {
      return Object.keys(TICKET_TYPE).map(key => ({
        value: key,
        label: TICKET_TYPE[key]
      }));
    }
  },
  watch: {
    ticketType(val, oldval) {
      if (val != oldval) {
        this.ticketType = val;
        this.getList({
          page: 1
        });
      }
    }
  },
  methods: {
    ...mapActions('loginUserTicket', ['list']),
    ...mapMutations('loginUserTicket', ['changeTab']),
    handleSearch() {
      this.getList({
        page: 1
      });
    },
    handleTabChange(tab) {
      this.changeTab(tab.name);
      this.getList({
        page: 1
      });
    },
    getList(data = {}) {
      const params = {
        status: this.activeTab
      };
      if (this.ticketType !== '') {
        params.type = this.ticketType;
      }
      if (this.userId !== '') {
        params.userId = this.userId;
      }
      this.list({
        ...params,
        ...this.pagination,
        ...data
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>

<style lang="less" scoped>
</style>
